import { render, staticRenderFns } from "./CardNovidade.vue?vue&type=template&id=d3bc65c8&scoped=true"
import script from "./CardNovidade.vue?vue&type=script&lang=js"
export * from "./CardNovidade.vue?vue&type=script&lang=js"
import style0 from "./CardNovidade.vue?vue&type=style&index=0&id=d3bc65c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3bc65c8",
  null
  
)

export default component.exports